import React, {useEffect, useState} from 'react';
import {FormControl, Grid, Input, InputAdornment, InputLabel, Tooltip} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {TextField} from "@material-ui/core";


export default function TextInputWithHelpText(props) {
    const [value, setValue] = useState(props.value || '');

    useEffect(() => {
        setValue(props.value || '');
    }, [props.value])

    const isBirthDate = props.id === 'BirthDate';

    const formatDateInput = (input) => {
        if (!isBirthDate) return input;
        
        // Remove all non-numeric characters
        const numbers = input.replace(/\D/g, '');
        
        // Limit to 8 digits (mmddyyyy)
        const limitedNumbers = numbers.slice(0, 8);
        
        // Format: m/d/yyyy (month/day/year)
        if (limitedNumbers.length === 0) return '';
        if (limitedNumbers.length <= 2) return limitedNumbers;
        if (limitedNumbers.length <= 4) return `${limitedNumbers.slice(0, 2)}/${limitedNumbers.slice(2)}`;
        return `${limitedNumbers.slice(0, 2)}/${limitedNumbers.slice(2, 4)}/${limitedNumbers.slice(4)}`;
    };

    const handleChange = (event) => {
        event.preventDefault();
        const inputValue = event.target.value;
        
        if (isBirthDate) {
            // For BirthDate, format automatically
            const formatted = formatDateInput(inputValue);
            setValue(formatted);
            props.handleChange(props.id, formatted);
        } else {
            // For other fields, use as-is
            setValue(inputValue);
            props.handleChange(props.id, inputValue);
        }
    };

    // Update label to include format hint for BirthDate
    const displayLabel = isBirthDate && props.label 
        ? `${props.label} (mm/dd/yyyy)`
        : props.label;

    return (
        <Grid container className={'center'} style={{maxWidth: '260px'}}>
            <Grid item xs={10}>
                <TextField
                    color={'secondary'}
                    style={{marginTop: '5px', marginBottom: '5px', width: '100%'}}
                    id={props.id}
                    label={displayLabel}
                    value={isBirthDate ? formatDateInput(value) : value}
                    required={props.required ? props.required : false}
                    onChange={handleChange}
                    disabled={props.disabled === true}
                    variant={props.variant !== undefined ? props.variant : 'standard'}
                    inputProps={isBirthDate ? {
                        inputMode: 'numeric',
                        pattern: '[0-9/]*',
                        maxLength: 10 // dd/mm/yyyy
                    } : {}}
                />
            </Grid>
            <Grid item xs={2} style={{paddingTop: '20px'}}>
                <Tooltip title={props.tooltip} style={{cursor: 'pointer'}}>
                    <InfoOutlinedIcon />
                </Tooltip>
            </Grid>
        </Grid>
    );
}